export class CategoryPrice {

  public id: string;
  public categories: any[] = []
  public foreigners_only: boolean
  public lot_id: string;
  public name: string;
  public product_id: string;

  public requires_doc: boolean;
  public list_doc: string;

  public show_on_site: boolean;
  public value: number;
  public value_defaulting: number;
  public value_pix: number;
  public value_defaulting_pix: number;
  public pix_discount: number;
  public partner: boolean;

  public docList: any;

  constructor () { }

}